// src/components/home/LatestReleases.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLibrary } from '../../context/LibraryContext';

const LatestReleases = () => {
  const { getLatestReleases, setSelectedRelease } = useLibrary();
  const navigate = useNavigate();
  
  const latestReleases = getLatestReleases(3);
  
  const handleReleaseClick = (release) => {
    setSelectedRelease(release);
    navigate('/discography');
  };
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {latestReleases.map((release) => (
        <div 
          key={release.id} 
          className="bg-gray-800 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow cursor-pointer"
          onClick={() => handleReleaseClick(release)}
        >
          <div className="h-60 overflow-hidden">
            <img 
              src={release.coverImage} 
              alt={release.title} 
              className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="p-6">
            <h3 className="text-xl font-semibold text-gray-100 mb-2">{release.title}</h3>
            <p className="text-gray-400 mb-4">
              Released: {new Date(release.releaseDate).toLocaleDateString()}
            </p>
            <p className="text-gray-300 text-sm">{release.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LatestReleases;  